import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  errorNotify,
  successNotify,
} from "../../../Components/ToastComponent/ToastNotification";
import TextInput from "../../../Components/InputComponents/TextInput";
import SelectInput from "../../../Components/InputComponents/SelectInput";
import CommonButton from "../../../Components/InputComponents/CommonButton";
import {
  Grid,
  Typography,
  Paper,
  Button,
  Checkbox,
  TextField,
  Autocomplete,
  RadioGroup,
  Box,
  Radio,
  FormControlLabel,
  Modal,
  IconButton,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ProcessView from "./ViewProcedureDetailsModal";

const EditRecruitmentProcedureMapping = () => {
  const navigate = useNavigate();

  const [candidateData, setCandidateData] = useState({
    country: "Saudi",
    recruitmentProcedure: "1",
    profession: "Nurse",
  });

  const recruitmentOptions = [
    {
      value: "1",
      label: "Saudi Recruitment Procedure 1",
      details: "Dataflow, VRS, VISA",
    },
    {
      value: "2",
      label: "Custom Recruitment Procedure",
      details: "Document Check, Interview, Final Approval",
    },
    {
      value: "3",
      label: "Recruitment Procedure - May",
      details: "VRS, Dataflow, Embassy Verification",
    },
    {
      value: "4",
      label: "RP_Medicity",
      details: "Medical Test, Dataflow, Final Visa",
    },
  ];

  const [openModal, setOpenModal] = useState(false);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [errors, setErrors] = useState({});

  const handleViewProcedure = (option) => {
    setSelectedProcedure(option);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedProcedure(null);
  };

  const validateForm = () => {
    const mandatoryFields = [
      { field: "country", label: "Country" },
      { field: "profession", label: "Profession" },
      { field: "recruitmentProcedure", label: "Recruitment Procedure" },
    ];

    let formErrors = {};
    for (let { field, label } of mandatoryFields) {
      if (!candidateData[field]) {
        formErrors[field] = `${label} is required.`;
      }
    }

    setErrors(formErrors);
    if (Object.keys(formErrors).length > 0) {
      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });
      return false;
    }
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });
    setCandidateData({
      ...candidateData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      successNotify("Candidate Added successfully!");
      // Save logic or redirect
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Paper
      sx={{
        padding: { xs: 2, sm: 3, md: 5 },
        margin: "auto",
        position: "relative",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        mb={2}
      >
        Edit Recruitment Procedure Mapping
      </Typography>

      <Grid
        container
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6}>
          <Typography variant="subtitle1"  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}>
            Country
          </Typography>
          <SelectInput
            value={candidateData.country}
            name="country"
            onChange={handleInputChange}
            options={[
              { value: "United Arab Emirates", label: "United Arab Emirates" },
              { value: "Qatar", label: "Qatar" },
              { value: "Kuwait", label: "Kuwait" },
              { value: "Oman", label: "Oman" },
              { value: "Bahrain", label: "Bahrain" },
              { value: "Saudi", label:"Saudi"}
            ]}
            placeholder="Select Country"
          />
        </Grid>

        <Grid item sx={{ padding: "5px" }} xs={12} sm={6}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}>
            Profession
          </Typography>
          <SelectInput
            value={candidateData.profession}
            name="profession"
            onChange={handleInputChange}
            options={[
              { value: "Doctor", label: "Doctor" },
              { value: "Nurse", label: "Nurse" },
              { value: "Pharmacist", label: "Pharmacist" },
              { value: "Lab Technician", label: "Lab Technician" },
            ]}
            placeholder="Select Profession"
          />
        </Grid>

        <Grid item xs={12} sx={{ padding: "5px" }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}>
            Recruitment Procedure
          </Typography>

          <RadioGroup
            value={candidateData.recruitmentProcedure}
            name="recruitmentProcedure"
            onChange={handleInputChange}
          >
            {recruitmentOptions.map((option) => (
              <Paper
                key={option.value}
                variant="outlined"
                sx={{
                  padding: 2,
                  marginBottom: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "2px solid",
                  borderColor:
                    candidateData.recruitmentProcedure === option.value
                      ? "primary.main"
                      : "grey.300",
                }}
              >
                <FormControlLabel
                  value={option.value}
                  control={<Radio />}
                  label={
                    <Box>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                        }}
                      >
                        {option.label}
                      </Typography>
                      <Typography variant="body2">{option.details}</Typography>
                    </Box>
                  }
                  sx={{ margin: 0 }}
                />

                <IconButton
                  onClick={() => handleViewProcedure(option)}
                  sx={{ ml: 2 }}
                >
                  <VisibilityIcon />
                </IconButton>
              </Paper>
            ))}
          </RadioGroup>
        </Grid>
      </Grid>

      <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() => {
              navigate(`/RecruitmentMappingProcedure`);
            }}
          >
            Cancel
          </CommonButton>
        </Grid>
        <Grid item>
          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={handleSubmit}
          >
            Save
          </CommonButton>
        </Grid>
      </Grid>

      <ProcessView
        open={openModal}
        handleClose={handleCloseModal}
        title={selectedProcedure?.label}
      />
    </Paper>
  );
};

export default EditRecruitmentProcedureMapping;
